export const updateSelectedValue = (value, id, state) => {
	return Promise.resolve({
		data: {
			...state.data,
			[id]: value
		}
	});
};

export const handleKeyPress = (event, actionHandler, handlerArgs = null) => {
	if (event.key === "Enter") {
		event.preventDefault();
		actionHandler(handlerArgs);
	}
};

export const handleInputChange = (event, state) => {
	const { id, value } = event.target;
	return {
		data: {
			...state.data,
			[id]: value
		}
	};
};

export const handleCheckboxClick = (event, state) => {
	const { id } = event.target;
	return Promise.resolve({
		data: {
			...state.data,
			[id]: !state.data[id]
		}
	});
};

export const handleRadioClick = (event, name, state) => {
	const { value } = event.target;
	return Promise.resolve({
		data: {
			...state.data,
			[name]: value
		}
	});
};

export const editorChange = (id, evt, state) => {
	const newContent = evt.editor.getData();
	const newData = {
		...state.data,
		[id]: newContent
	};

	return Promise.resolve({ data: newData });
};

export const handleDateChange = (e, id, state) => {
	return Promise.resolve({
		data: {
			...state.data,
			[id]: e
		}
	});
};

// ===================================================================================
//  Collections
// ===================================================================================
/**
 * Adds a blank value to an array within the state.  For basic inputs with just a value.  Not objects.
 *
 * @param fieldName Name of the field array we'll be adding to
 * @param state     Initial state to alter
 */
export const addInputToCollection = (fieldName, state) => {
	return Promise.resolve({
		data: {
			...state.data,
			[fieldName]: [...state.data[fieldName], ""]
		}
	});
};

/**
 * Removes an item from an array collection within the state
 *
 * @param fieldName Name of the field array we'll be adding to
 * @param index Position of the array item we are changing
 * @param state Initial state to alter
 */
export const deleteInputFromCollection = (fieldName, index, state) => {
	return Promise.resolve({
		data: {
			...state.data,
			[fieldName]: [
				...state.data[fieldName].slice(0, index),
				...state.data[fieldName].slice(index + 1)
			]
		}
	});
};

/**
 * Will update an item's value in an array collection
 *
 * @param event Usually the keypress event (has a target)
 * @param index Position of the array item we are changing
 * @param state Initial state to alter
 */
export const handleInputChangeArray = (event, index, state) => {
	const { name, value } = event.target;

	return Promise.resolve({
		data: {
			...state.data,
			[name]: state.data[name].map((item, i) => {
				if (i !== index) {
					return item;
				}

				return value;
			})
		}
	});
};

/**
 * Adds a phone number object to an array within the state.
 * This is specifically for phone objects { phone: "", extension: "" }
 *
 * @param fieldName Name of the field array we'll be adding to
 * @param state     Initial state to alter
 */
export const addPhoneInputToCollection = (fieldName, state) => {
	return Promise.resolve({
		data: {
			...state.data,
			[fieldName]: [...state.data[fieldName], { phone: "", extension: "" }]
		}
	});
};

/**
 * This function works with an object and assumes the state holds an array of objects with an id.
 * We will of course be using the id's to figure out if it's on/off
 *
 * @param obj         Object that hold at least an id used to determine if the item's already in the state { id: x }
 * @param fieldName   Name of the field array we'll be adding to
 * @param state       Initial state to alter
 * @param objectIndex (optional) Index of the object to compare. It may be different than 'id'.
 */
export const handleCheckboxClickArray = (obj, fieldName, state, objectIndex = "") => {
	// Clone array we will be updating
	let newState = [...state.data[fieldName]];

	if (objectIndex === "") objectIndex = "id";

	// Find index of the id within the cloned array
	const indexOf = newState.findIndex(item => item[objectIndex] === obj[objectIndex]);

	// If index was not found (-1) then we should immutably concat() the a new object onto the array
	if (indexOf < 0) {
		newState = newState.concat(obj);
	}
	// The index was found, so let's remove it immutably
	else {
		newState = newState.slice(0, indexOf).concat(newState.slice(indexOf + 1));
	}

	return Promise.resolve({
		data: {
			...state.data,
			[fieldName]: [...newState]
		}
	});
};

// ===================================================================================
//  RECAPTCHA
// ===================================================================================
/**
 * RECAPTCHA update handler
 *
 * @param value recaptcha's validation value (passed into this from onVerify() when user clicks on the "I'm not a robot" button or whatever)
 * @param state Initial state to alter
 */
export const recaptchChanged = (value, state) => {
	return Promise.resolve({
		data: {
			...state.data,
			recaptcha: value
		}
	});
};



// WEBPACK FOOTER //
// ./src/utils/forms/inputHandling.js